module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-2 overline grey darken-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('center', [_c('v-progress-circular', {
    staticClass: "mt-5",
    attrs: {
      "indeterminate": "",
      "size": "72",
      "color": "amber"
    }
  }), _c('br'), _vm._v("\n    Loading ..\n  ")], 1) : _vm._e(), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "id": "settingsiframe",
      "src": _vm.src,
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.iframeloaded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5804d056","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AgIframe.vue
// module id = 1433
// module chunks = 9